import React, { useMemo, Suspense, lazy, useEffect } from 'react'

import { getSafe } from '@sponte/lib-utils/dist/helpers/object'

import { SptLoading } from '@sponte/lib-components/dist/atoms/Loading'

import { getExistPendingTerm } from 'services/auth'
import { getSubdominioWeb } from 'services/tenants'

import { useAuth } from 'providers/auth'
import { useTenant } from 'providers/tenant'

const Auth = lazy(() => import('./pages/auth'))
const Admin = lazy(() => import('./pages/admin'))
const Tenant = lazy(() => import('./pages/tenant'))
const Errors = lazy(() => import('./pages/errors'))

const App = () => {
  const { eu } = useAuth()
  const { tenant } = useTenant()
  const idIdiomas = '78f8ef47-2dd7-4fcb-846e-12e716cf67aa'
  const isIdiomas = useMemo(() => getSafe(tenant, 'verticalMercadoId') === idIdiomas, [idIdiomas, tenant])

  useEffect(() => {
    document.title = isIdiomas ? 'Agenda Plus - Idiomas' : 'Agenda Plus - Educacional'
  }, [isIdiomas])

  const Component = useMemo(() => {
    if (getSubdominioWeb() && !tenant) {
      return Errors
    }

    if (!tenant) {
      return Tenant
    }

    if (!eu) {
      return Auth
    }

    if (getExistPendingTerm() && getExistPendingTerm() === 'true') {
      return Auth
    }

    return Admin
  }, [tenant, eu])

  return (
    <Suspense fallback={<SptLoading full size="xl" position="absolute" />}>
      <Component />
      <UserGuidingInputs eu={eu} />
    </Suspense>
  )
}

const UserGuidingInputs = ({ eu }) => {
  return (
    <div id="ctl00_divinfoGeral" style={{ display: 'none' }}>
      <input
        type="hidden"
        name="ctl00$infCodCli"
        id="ctl00_infCodCli"
        value={getSafe(eu, 'contaAtual.codigoContrato', '')}
      />
      <input
        type="hidden"
        name="ctl00$infNomeEscola"
        id="ctl00_infNomeEscola"
        value={getSafe(eu, 'contaAtual.pessoaJuridica.pessoa.nomeCompleto', '')}
      />
      <input type="hidden" name="ctl00$infUsuarioID" id="ctl00_infUsuarioID" value={getSafe(eu, 'id', '')} />
      <input
        type="hidden"
        name="ctl00$infNomeUsuario"
        id="ctl00_infNomeUsuario"
        value={getSafe(eu, 'pessoa.nomeCompleto', '')}
      />
    </div>
  )
}

export default App
